import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/fonts.css';
import './styles/app.css';
import { SessionProvider } from './lib/session';
import { App } from './App';

// When the app is served under a sub-path (VITE_BASE, e.g. `/preview/`), Vite
// exposes it as import.meta.env.BASE_URL. Feed it to the router as the basename
// so every route resolves under that prefix; default `/` for a root deploy.
const rawBase = import.meta.env.BASE_URL;
const basename = rawBase.length > 1 ? rawBase.replace(/\/$/, '') : rawBase;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SessionProvider>
      <BrowserRouter basename={basename}>
        <App />
      </BrowserRouter>
    </SessionProvider>
  </React.StrictMode>,
);
